import React from "react";
class SearchBar extends React.Component {
    state = {
        dropdownOpen: "hide",
        dropdownItemActive: !this.props.params.dateRange ? "Filter By Date" : this.props.params.dateRange,
        dropdownArrow: "down",
        searchTerm: this.props.params.subtitle
    }

    handleFilterChange = e => {
        const filters = document.getElementsByClassName("filter");

        for(let i = 0; i < filters.length; i++){
            filters[i].classList.remove("selected");
        }

        e.target.classList.add("selected");
    }

    handleDropDownItemChange = e => {
        e.stopPropagation();

        this.setState({
            dropdownItemActive: e.target.value
        });

        this.dropdownToggle();
    }

    handleInputChange = e => {
        e.preventDefault();
        e.stopPropagation();

        this.setState({
            searchTerm: e.target.value
        });
    }

    onMouseEnter = () => {
        this.setState({
            dropdownOpen: "",
            dropdownArrow: "up"
        });
    }

    onMouseLeave = () => {
        this.setState({
            dropdownOpen: "hide",
            dropdownArrow: "down"
        });
    };

    renderInlineSearchFilters = () => {
        return this.props.data.inline.map( (item, index) => {
            const selected = index === 0 ? "selected" : "";

            return (
                <h5 className={`filter ${selected}`} onClick={this.handleFilterChange} key={`${item}-filter`}>{item}</h5>
            );
        });
    }

    render(){
        return (
            <div className="searchbar-container">
                <h3>
                    {this.props.params.title}
                </h3>
                <form className="lm-searchform" method="get" action="/search">
                    <div className="search-fields">
                        <div className="input-wrapper">
                            <i className="far fa-search" aria-hidden="true"/>
                            <input className="input-standard" type="text" name="for" value={this.state.searchTerm} onChange={this.handleInputChange}/>
                        </div>
                        <input className="btn" type="submit" value="Search"></input>
                    </div>
                    <div className="search-filters" method="get" action="/search">
                        {this.renderInlineSearchFilters()}
                        <h5 className="dropdown-filter" onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
                            {`${this.state.dropdownItemActive}`}
                            {this.state.dropdownArrow == "up" ? <i className="fas fa-arrow-up" aria-hidden="true" style={{marginLeft: "5px"}}/> : <i className="fas fa-arrow-down" aria-hidden="true" style={{marginLeft: "5px"}}/>}
                            <div className={`dropdown-options ${this.state.dropdownOpen}`}>
                                {
                                    this.props.data.dropdown.map( item => {
                                        if(this.state.dropdownItemActive !== item){
                                            return (
                                                <input
                                                    className="dropdown-item"
                                                    key={`${item}-dateFilter`}
                                                    value={item}
                                                    name="dateRange"
                                                    type="submit"
                                                />
                                            );
                                        }
                                    })
                                }
                            </div>
                        </h5>
                    </div>
                </form>
            </div>
        );
    }
}

export default SearchBar;
